import { defineStore } from "pinia";

export const useContactStore = defineStore("ContactPurpose", {
  state: () => ({
    purposeMsg: [],
    sourceMsg: [],
  }),
  getters: {},
  actions: {
    async contactUsSendEmail(params) {
      try {
        return await $fetch("/api/myspilcom/spilcoid-contact-us", {
          method: "POST",
          body: params,
        });
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async sendMessage(params) {
      try {
        return await $fetch("/api/contact/send-message", {
          method: "POST",
          body: params,
        });
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async sendMySpilMessage(params) {
      try {
        return await $fetch("/api/contact/send-message-myspil", {
          method: "POST",
          body: params,
        });
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getPurpose() {
      try {
        const res = await $fetch("/api/contact/get-purpose", {
          method: "POST",
        });
        this.purposeMsg = res.data;
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },

    async getSource() {
      try {
        const res = await $fetch("/api/contact/get-source", {
          method: "POST",
        });
        this.sourceMsg = res.data;
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },
  },
});
